module.exports = __webpack_public_path__ + "static/media/intersection.5d18b78b.svg";